import { isWeb } from '~/utils/helper/device';
import { EduCode, GaEventPayload, TrackingEventName, UserRole } from './type';

const isGtagAvailable = (eventName: string): boolean => {
  if (typeof window === 'undefined') {
    console.warn('[gtag] window is undefined, event skipped:', eventName);
    return false;
  }
  if (typeof window.gtag !== 'function') {
    console.warn(
      '[gtag] window.gtag is not a function, event skipped:',
      eventName,
    );
    return false;
  }
  return true;
};

let platformPropertySet = false;

const ensurePlatformProperty = () => {
  if (platformPropertySet) return;
  window.gtag('set', 'user_properties', { electron: !isWeb });
  platformPropertySet = true;
};

export const setGaUserRole = (role: UserRole) => {
  try {
    if (!isGtagAvailable('set user_role')) return;
    ensurePlatformProperty();
    window.gtag('set', 'user_properties', { user_role: role });
  } catch (error) {
    console.error('[gtag] setGaUserRole error:', error);
  }
};

export const setGaEduCode = (edu: EduCode) => {
  try {
    if (!isGtagAvailable('set edu_code')) return;
    window.gtag('set', 'user_properties', { edu_code: edu });
  } catch (error) {
    console.error('[gtag] setGaEduCode error:', error);
  }
};

export const sendGaEvent = (
  eventName: TrackingEventName,
  payload: GaEventPayload = {},
) => {
  try {
    if (!isGtagAvailable(eventName)) return;
    ensurePlatformProperty();
    window.gtag('event', eventName, {
      app_version: import.meta.env.VITE_PUBLIC_VERSION ?? '1.0.0',
      ...payload,
    });
  } catch (error) {
    console.error('[gtag] sendGaEvent error:', eventName, error);
  }
};
